// extracted by mini-css-extract-plugin
module.exports = {"Loading":"PreloadImage_Loading__2fC0i","Error":"PreloadImage_Error__2x-3b"};